import { render, staticRenderFns } from "./TipoServicoRoute.vue?vue&type=template&id=72c96ff3"
import script from "./TipoServicoRoute.vue?vue&type=script&lang=js"
export * from "./TipoServicoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports